__turbopack_context__.v({
  "label": "label-module-scss-module__oAy33a__label",
});
